import { ArrowRight, TrendUp } from "@phosphor-icons/react";
import { Reveal, ChapterTag } from "./Reveal";
import { useDownload } from "@/lib/download";

const ROWS = [
  { label: "Exchange Pair", value: "USDT → INR" },
  { label: "INR Payout", value: "Bank Withdrawal" },
  { label: "Rate Updates", value: "Real-time in app" },
];

export default function RateSection() {
  const { startDownload } = useDownload();

  return (
    <section id="rates" data-testid="rate-section" className="relative py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12">
        <Reveal className="lg:col-span-6">
          <ChapterTag index="01" label="Rates" />
          <h2 className="mt-6 font-display text-3xl font-extrabold tracking-tighter text-slate-50 sm:text-5xl">
            Best USDT to INR Rates, <span className="text-[#00F5A0]">Every Time</span>
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-slate-400 sm:text-lg">
            Coin Adda tracks the market so you always exchange at a sharp,
            transparent rate. The exact live rate is shown inside the app
            before you confirm — no hidden spreads, no surprises.
          </p>
          <button
            type="button"
            data-testid="rate-section-cta"
            onClick={startDownload}
            className="group mt-8 inline-flex items-center gap-2 text-base font-semibold text-[#00F5A0]"
          >
            Check today's rate in the app
            <ArrowRight size={18} weight="bold" className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-6">
          <div className="relative">
            <div
              aria-hidden
              className="absolute -inset-6 -z-10 rounded-[2.5rem] bg-[radial-gradient(circle_at_30%_20%,rgba(0,245,160,0.14),transparent_70%)] blur-2xl"
            />
            <div
              className="rounded-[2rem] border border-white/10 bg-[#0F172A]/70 p-8 backdrop-blur-xl sm:p-12"
              data-testid="rate-card"
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-slate-400">
                  <TrendUp size={16} weight="duotone" className="text-[#00F5A0]" />
                  Exchange Rate
                </span>
                <span className="inline-flex items-center gap-2 rounded-full border border-[#00F5A0]/25 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#00F5A0]">
                  <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#00F5A0]" />
                  Live in App
                </span>
              </div>

              <p className="mt-8 font-mono text-4xl font-bold tracking-tight text-slate-50 sm:text-6xl" data-testid="rate-card-value">
                1 USDT <span className="text-slate-500">=</span> <span className="text-[#00F5A0]">₹ --.--</span>
              </p>
              <p className="mt-3 text-sm text-slate-400">
                Your exact live rate appears in the Coin Adda app before every exchange.
              </p>

              <div className="mt-8 divide-y divide-white/10 border-t border-white/10">
                {ROWS.map((row) => (
                  <div key={row.label} className="flex items-center justify-between py-4">
                    <span className="text-sm text-slate-400">{row.label}</span>
                    <span className="font-mono text-sm font-medium text-slate-100">{row.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
